import { Checkbox } from "antd";

const forms = [
  {
    name: "Details",
    options: [
      {
        name: "Role",
        type: "input",
        form: {
          type: "text",
          name: "name",
          placeholder: "Role name",
          class: "",
          value: "",
          required: true,
        },
      },
    ],
  },

  {
    name: "Status",
    options: [
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;
